const SITE_ACCESS_KEY_PREFIX = "cuo_partner_site_access:";

const SLUG_CODE_ENV: Record<string, string> = {
  "dr-squatch": "VITE_PARTNER_DR_SQUATCH_ACCESS_CODE",
  skrewball: "VITE_PARTNER_SKREWBALL_ACCESS_CODE",
  "draft-kings": "VITE_PARTNER_DRAFT_KINGS_ACCESS_CODE",
  "amex-esb": "VITE_PARTNER_AMEX_ESB_ACCESS_CODE",
  "bilt-esb": "VITE_PARTNER_BILT_ESB_ACCESS_CODE",
  "delta-esb": "VITE_PARTNER_DELTA_ESB_ACCESS_CODE",
  "united-esb": "VITE_PARTNER_UNITED_ESB_ACCESS_CODE",
  "capital-one-esb": "VITE_PARTNER_CAPITAL_ONE_ESB_ACCESS_CODE",
  "draft-kings-stadium": "VITE_PARTNER_DK_STADIUM_ACCESS_CODE",
  "food-tour": "VITE_PARTNER_FOOD_TOUR_ACCESS_CODE",
  "hexclad-food-tour": "VITE_PARTNER_HEXCLAD_FOOD_TOUR_ACCESS_CODE",
  gti: "VITE_PARTNER_GTI_ACCESS_CODE",
  airbnb: "VITE_PARTNER_AIRBNB_ACCESS_CODE",
};

function envValue(key: string): string {
  const raw = import.meta.env[key];
  return typeof raw === "string" ? raw.trim() : "";
}

export function getPartnerAccessCode(slug: string): string | null {
  const envKey = SLUG_CODE_ENV[slug];
  if (!envKey) return null;
  const accessCode = envValue(envKey);
  return accessCode || null;
}

export function usesPartnerSiteAccess(slug: string): boolean {
  return getPartnerAccessCode(slug) != null;
}

export function isValidPartnerAccessCode(slug: string, code: string): boolean {
  const accessCode = getPartnerAccessCode(slug);
  if (!accessCode) return false;
  const entered = code.trim();
  if (slug === "capital-one-esb" || slug === "gti") {
    return entered.toLowerCase() === accessCode.toLowerCase();
  }
  return entered === accessCode;
}

export function hasStoredSiteAccess(slug: string): boolean {
  try {
    return sessionStorage.getItem(`${SITE_ACCESS_KEY_PREFIX}${slug}`) === "1";
  } catch {
    return false;
  }
}

export function storeSiteAccessSession(slug: string): void {
  try {
    sessionStorage.setItem(`${SITE_ACCESS_KEY_PREFIX}${slug}`, "1");
  } catch {
    // ignore quota / private mode
  }
}
